import React from "react";
import { Form } from "@redriver/cinnamon";
import { getEnquirySourcesLookup } from "./actions";

const EnquirySourcesLookupDropdown = (props) => (
  <Form.Dropdown {...props} lookupAction={getEnquirySourcesLookup} />
);

export default EnquirySourcesLookupDropdown;
